// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { ReviewOutcomeOutcomeFragmentDoc } from './ReviewOutcome.generated';
export type ReviewPackageOrderFragment = {
  __typename?: 'Order';
  packageOrder?: {
    __typename?: 'OfferingPackage';
    id: string;
    name: string;
    visibility: Types.PackageVisibility;
    category?: { __typename?: 'Category'; id: string; name: string } | null;
  } | null;
};

export type ReviewClassOrderFragment = {
  __typename?: 'Order';
  classOrder?: {
    __typename?: 'ClassOrder';
    coachingSession: {
      __typename?: 'CoachingSession';
      id: string;
      content:
        | { __typename?: 'BootcampSession' }
        | { __typename?: 'Class'; id: string; name?: string | null }
        | { __typename?: 'OneOnOneSession' };
    };
  } | null;
};

export type ReviewReviewFragment = {
  __typename?: 'Review';
  id: string;
  anonymous: boolean;
  rate: number;
  overallRate: number;
  headline?: string | null;
  comment?: string | null;
  guestReviewer?: string | null;
  reviewedAt: number;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  };
  categoryReviews?: Array<{
    __typename?: 'CategoryReview';
    responsiveness?: number | null;
    supportiveness?: number | null;
    knowledge?: number | null;
    value?: number | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      slug: string;
      isFeatured: boolean;
      goal: Types.GoalName;
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
      }> | null;
    };
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      name: string;
    }> | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'JobOfferInfo';
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        };
      }
    | {
        __typename?: 'SchoolAdmissionInfo';
        status?: Types.SchoolAdmissionStatus | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }
    | { __typename?: 'TestScoreV2'; score: number; testName: string }
  > | null;
  mostRecentOrder?: {
    __typename?: 'Order';
    id: string;
    classOrder?: {
      __typename?: 'ClassOrder';
      coachingSession: {
        __typename?: 'CoachingSession';
        id: string;
        content:
          | { __typename?: 'BootcampSession' }
          | { __typename?: 'Class'; id: string; name?: string | null }
          | { __typename?: 'OneOnOneSession' };
      };
    } | null;
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      visibility: Types.PackageVisibility;
      category?: { __typename?: 'Category'; id: string; name: string } | null;
    } | null;
  } | null;
  mostRecentClassSession?: {
    __typename?: 'CoachingSession';
    id: string;
    content:
      | { __typename?: 'BootcampSession' }
      | {
          __typename?: 'Class';
          id: string;
          name?: string | null;
          isFreeEvent?: boolean | null;
        }
      | { __typename?: 'OneOnOneSession' };
  } | null;
};

export const ReviewClassOrderFragmentDoc = gql`
  fragment Review_ClassOrder on Order {
    classOrder {
      coachingSession {
        id
        content {
          ... on Class {
            id
            name
          }
        }
      }
    }
  }
`;
export const ReviewPackageOrderFragmentDoc = gql`
  fragment Review_PackageOrder on Order {
    packageOrder {
      id
      name
      visibility
      category {
        id
        name
      }
    }
  }
`;
export const ReviewReviewFragmentDoc = gql`
  fragment Review_Review on Review {
    id
    anonymous
    applicant {
      id
      user {
        id
        firstName
        lastName
        pictureLink
        email
      }
    }
    coach {
      id
      slug
      user {
        id
        firstName
        lastName
        pictureLink
        email
      }
    }
    rate
    overallRate
    headline
    comment
    categoryReviews {
      category {
        id
        name
        slug
        coachingFocusList {
          id
          name
        }
        isFeatured
        goal
      }
      subCategoryList {
        name
      }
      responsiveness
      supportiveness
      knowledge
      value
    }
    outcomes {
      ...ReviewOutcome_Outcome
    }
    guestReviewer
    reviewedAt
    mostRecentOrder {
      id
      ...Review_ClassOrder
      ...Review_PackageOrder
    }
    mostRecentClassSession {
      id
      content {
        ... on Class {
          id
          name
          isFreeEvent
        }
      }
    }
  }
  ${ReviewOutcomeOutcomeFragmentDoc}
  ${ReviewClassOrderFragmentDoc}
  ${ReviewPackageOrderFragmentDoc}
`;
